import { render, staticRenderFns } from "./prebuild-pcs-banner.vue?vue&type=template&id=2feac9be&scoped=true&"
import script from "./prebuild-pcs-banner.vue?vue&type=script&lang=js&"
export * from "./prebuild-pcs-banner.vue?vue&type=script&lang=js&"
import style0 from "./prebuild-pcs-banner.vue?vue&type=style&index=0&id=2feac9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feac9be",
  null
  
)

export default component.exports